import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { AFFILIATE_PROGRAM_CREATIVES_PERMISSIONS } from '@modules/affiliate-program-creatives/constants';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type {
  IAffiliateProgramCreativeFormFields,
  IAffiliateProgramCreativeGetResponse,
} from '../types';
import {
  AFFILIATE_PROGRAM_CREATIVES_GET_QUERY_KEY,
  AFFILIATE_PROGRAM_CREATIVES_GET_URL,
} from '../constants';

export default function useAffiliateProgramCreativeGetQuery(
  id: Ref<number>,
): IContextQueryResult<
    IAffiliateProgramCreativeGetResponse,
    Error,
    IAffiliateProgramCreativeFormFields
  > {
  const { fetchGet } = useRestClient();

  return useContextQuery<
    IAffiliateProgramCreativeGetResponse,
    Error,
    IAffiliateProgramCreativeFormFields
  >({
    queryKey: [AFFILIATE_PROGRAM_CREATIVES_GET_QUERY_KEY, id],
    queryFn: ({ signal }) => fetchGet<IAffiliateProgramCreativeGetResponse>(
      AFFILIATE_PROGRAM_CREATIVES_GET_URL,
      {
        signal,
        permission: AFFILIATE_PROGRAM_CREATIVES_PERMISSIONS.EDIT,
        urlParams: {
          id: id.value,
        },
      },
    ),
    select: (data) => data.creative,
    enabled: computed(() => !!id.value),
  });
}
